import ArrowLink from "common/ArrowLink/ArrowLink";
import dayjs from "dayjs";

const Resources = ({ labels, resources, participantDetails, clientConfig }) => {
  const getResourceLink = (data) => {
    const planState = participantDetails?.planStateCode;
    const planId = participantDetails?.extPlanId;
    return data?.link[planState] || data?.link[planId] || data?.link["ALL"];
  };

  const filterResources = (resources) => {
    if (
      participantDetails?.planStateCode !== "NJ" &&
      clientConfig?.planStateCodeCheck === "true"
    ) {
      resources.pop();
    }

    const planOnboardedDate = dayjs(participantDetails?.planOnboardedDate);
    let closestSOU = null;
    let closestDate = null;

    for (const resource of resources) {
      if (resource.id === "sou" && resource.date) {
        const souDate = dayjs(resource.date);
        if (
          souDate.isBefore(planOnboardedDate) &&
          (!closestDate || souDate.isAfter(closestDate))
        ) {
          closestSOU = resource;
          closestDate = souDate;
        }
      }
    }

    const filtered = resources.filter(
      (resource) => resource.id !== "sou" || resource === closestSOU
    );
    resources.length = 0;
    resources.push(...filtered);

    return resources;
  };

  return (
    <section className="section-one row py-4 resources">
      <div className="row align-items-center">
        <div className=" col-12 col-md-6 parent resource-left">
          <div className="header mb-4 py-1">
          {labels?.learningCenter?.resources}
          </div>
          <div className="d-flex flex-wrap resourceLinks links-mobile">
            {filterResources(resources).map((e) => (
              <div className="col-12 col-md-6" key={e.name}>
                <ArrowLink
                  wrapperClassName="links mb-3"
                  link={e.type !== "internal" && getResourceLink(e)}
                  path={e.type === "internal" && getResourceLink(e)}
                  text={e.name}
                  description={e.description}
                  iconName={labels?.learningCenter?.resourceIconName}
                />
              </div>
            ))}
          </div>
        </div>
        <div className="col-12 col-md-6 resource-image">
        </div>
      </div>
    </section>
  );
};

export default Resources;
